import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";

export const PieceImageViewer = ({
  src,
  alt,
  close,
}: {
  src: string;
  alt: string;
  close: () => void;
}) => {
  const play = usePlaySound();
  const handleClose = () => {
    play();
    btnDelay(() => close());
  };
  return (
    <div className="flex-col-el flex-center absolute inset-0 z-[1000] bg-white">
      <div className="absolute top-4 left-4 z-10 upsilon">
        <button
          type="button"
          onClick={handleClose}
          aria-label="back"
          className="type-inherit-font btn btn-blue"
        >
          <div className="flex-row-center gap-1">
            <span className="material-symbols-outlined text-white type-sm">arrow_back</span>
            <p className="type-text type-sm text-white whitespace-nowrap">
              {I18n.t("MSG_BACK_BTN")}
            </p>
          </div>
        </button>
      </div>
      <img alt={alt} src={src} className="h-full object-contain" />
    </div>
  );
};
